import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import UIButton from "../UIButton";
import { clx } from "../../../utils/Helpers";
import "./UIEmptyState.scss";

const UIEmptyState = ({
  title,
  description,
  icon,
  illustration,
  actionLabel,
  actionIcon,
  onAction,
  actionButtonProps,
  classNames,
}) => {
  const classes = clx("ui-empty-state", classNames.root);
  const descriptionClasses = clx(
    "ui-empty-state__description",
    classNames.description,
    "text-body-md",
  );

  return (
    <div className={classes}>
      {illustration ? (
        <div
          className={clx(
            "ui-empty-state__illustration",
            classNames.illustration,
          )}
          aria-hidden="true"
        >
          {illustration}
        </div>
      ) : null}
      {!illustration && icon ? (
        <div
          className={clx("ui-empty-state__icon-circle", classNames.iconCircle)}
          aria-hidden="true"
        >
          {icon}
        </div>
      ) : null}
      <div className="ui-empty-state__content">
        <Typography
          variant="h2"
          className={clx(
            "ui-empty-state__title",
            "text-heading-xl",
            classNames.title,
          )}
        >
          {title}
        </Typography>
        {description ? (
          <Typography variant="body1" className={descriptionClasses}>
            {description}
          </Typography>
        ) : null}
      </div>
      {actionLabel && onAction ? (
        <UIButton
          appearance="gradient"
          size="medium"
          type="button"
          startIcon={actionIcon}
          onClick={onAction}
          {...actionButtonProps}
        >
          {actionLabel}
        </UIButton>
      ) : null}
    </div>
  );
};

UIEmptyState.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  icon: PropTypes.node,
  illustration: PropTypes.node,
  actionLabel: PropTypes.node,
  actionIcon: PropTypes.node,
  onAction: PropTypes.func,
  actionButtonProps: PropTypes.object,
  classNames: PropTypes.object,
};

UIEmptyState.defaultProps = {
  description: null,
  icon: null,
  illustration: null,
  actionLabel: null,
  actionIcon: null,
  onAction: undefined,
  actionButtonProps: undefined,
  classNames: {},
};

export default UIEmptyState;
